/* @flow weak */
import { Record } from "../transit";

const State = Record(
  {
    host: ""
  },
  "device"
);

const deviceReducer = (state = new State()) => state;

export default deviceReducer;



// WEBPACK FOOTER //
// ./src/common/device/reducer.js